export enum LotType {          // tương ứng với giá trị quy ước trên backend
    CONTRACT_LOT = 'CONTRACT_LOT',
    USER_LOT = 'USER_LOT',
    CUSTOMER_LOT = 'CUSTOMER_LOT',
    CONTRACT_MOHA_LOT = 'CONTRACT_MOHA_LOT',
    CONTRACT_MOHA_STANDARDIZED_LOT = 'CONTRACT_MOHA_STANDARDIZED_LOT',
    CONTRACT_MOHA_LOT_DIGITAL = 'CONTRACT_MOHA_LOT_DIGITAL'
}
